const E405 = () => (
  <div className="error-container error-405">
    <h1>405</h1>
    <p className="title">Method Not Allowed</p>
    <p>The method used in the request is not allowed for this resource.</p>
  </div>
);

export default E405;